// extracted by mini-css-extract-plugin
export var titleH2 = "titleH2-module--title-h2--MeWaX";